import { Page } from 'components/Page'
import { PageHeader } from 'components/Shared/PageHeader'
import { BadgesTable } from 'components/Badges/BadgesTable'

export const LocationBadgesPage = () => {
  return (
    <Page header={<PageHeader title="Location Badges" />}>
      <BadgesTable category="LocationBadge" />
    </Page>
  )
}
